import { BrowserRouter as Router } from "react-router-dom";
import AppRoutes from "./routes/AppRoutes";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "./theme";
import { AuthProvider } from "./contexts/AuthContext";
import { useEffect } from "react";
import { initLiff, liffRedirectUrl } from "./config/liff";
import "./App.css";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient, logger } from "./utils/helper";
import { BRAND_UI } from "@/constants";

function App() {
  const mode = import.meta.env.VITE_MODE;

  useEffect(() => {
    document.title = BRAND_UI.brand.siteTitle;
  }, []);

  useEffect(() => {
    let isMounted = true;

    const init = async () => {
      try {
        const liff = await initLiff();
        await liff.ready;
        if (liff.isLoggedIn()) {
          const profile = await liff.getProfile();
          logger.info("LIFF init success", profile);
          if (isMounted) {
            localStorage.setItem("userId", profile.userId);
          }
        } else {
          liff.login({
            redirectUri: liffRedirectUrl,
          });
        }
      } catch (err) {
        logger.error("LIFF init failed", err);
      } finally {
        logger.info("✅ User is logged in");
      }
    };
    if (mode !== "debug") {
      init();
    }

    return () => {
      isMounted = false;
    };
  }, [mode]);

  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <ThemeProvider theme={theme}>
          <Router>
            <AppRoutes />
          </Router>
        </ThemeProvider>
      </AuthProvider>
    </QueryClientProvider>
  );
}

export default App;
